import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject
export class LearnCertType {
  /**
   * å®ä½id
   */
  @JsonProperty('id', Number, true)
  id: number = undefined;

  /**
   * åå»ºæ¶é´, æ¶é´æ³
   */
  @JsonProperty('createTime', Number, true)
  createTime: number = undefined;

  /**
   * æåä¿®æ¹æ¶é´, æ¶é´æ³
   */
  @JsonProperty('lastModified', Number, true)
  lastModified: number = undefined;

  @JsonProperty('name', String)
  name: string = undefined;

  @JsonProperty('learnCertClassId', Number)
  learnCertClassId: number = undefined;

  @JsonProperty('enabled', Boolean)
  enabled: boolean = undefined;

  // å­¦ä¹ å­æ®ç¦ç¨éç½®çæ è¯
  @JsonProperty('disabled', Boolean, true)
  disabled = false;

  @JsonProperty('idx', Number)
  idx: number = undefined;

  instanceOf(className: string): boolean {
    return 'LearnCertType' === className;
  }
}
